import { connect } from 'react-redux';
import { SessionSiteSelectors } from '../../selectors/SessionInfoSelectors';
import { AppState } from '../../state/AppState';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { DetailedDatasourceThumbnail, DetailedDatasourceThumbnailStateProps } from './DetailedDatasourceThumbnail';

const mapStateToProps: MapStateToProps<DetailedDatasourceThumbnailStateProps> = (state: AppState) => {
  return {
    siteEARMode: SessionSiteSelectors.extractEncryptionMode(state)
  };
};

export const ConnectedDetailedDatasourceThumbnail = connect(mapStateToProps)(DetailedDatasourceThumbnail);
